<template>
    <div id="registor">
        <div class="container">
            <div class="login-box" align="center">
                <h1 class="main-text" align="center">
                使用券码并下载应用
                </h1>
                <p class="sub-text">
                    激活码已成功绑定到 <span style="color: #f7419c; font-weight: 500;">{{$store.getters.getEmail}}</span> 账号。<br>
                    请使用该都都英语账号登录App。
                </p>
                <div class="coupon-bg">
                    <p>{{code}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['code'],

}
</script>
<style src="@/assets/coupon/complete.css" scoped></style>
<style scoped>
@media (max-width: 720px) {
    input {-webkit-appearance: none;-moz-appearance: none;appearance: none;}
}
</style>


// WEBPACK FOOTER //
// src/pages/coupon/Complete.vue